import axios from 'axios';

const url = process.env.REACT_APP_API;
// const COOKIE_NAME = 'vtex_admin_token'; // nuevo nombre

const setCookie = (name, value, minutes) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + minutes * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; Secure`;
};




export const loginUser = (credentials) => async (dispatch) => {
  try {
    const response = await axios.post(`${url}/auth/login`, credentials);
    const token = response.data.access_token;
    // setCookie(COOKIE_NAME, token, 7);
        setCookie('access_token', token, 600);
    dispatch({ type: 'LOGIN_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'LOGIN_FAILURE', payload: error.message });
    throw new Error(error.response ? error.response.data.message : 'Error de conexión');
  }
};

export const restoreAuth = () => async (dispatch) => {
  const cookieString = document.cookie
    .split('; ')
    .find((row) => row.startsWith('access_token='));
  if (!cookieString) {
    // No hay token en cookies, no hacemos nada
    return;
  }

    // .find((row) => row.startsWith(`${COOKIE_NAME}=`));

  // if (!cookieString) return;

  dispatch({ type: 'LOGIN_SUCCESS', payload: 'ok' });
};
